import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import MagicLogin, { GoogleCallback } from "@/pages/AuthCallback";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { I18nProvider } from "@/lib/i18n";
import AppLayout from "@/components/layout/AppLayout";
import Login from "@/pages/Login";
import Guide from "@/pages/Guide";
import Showcase from "@/pages/Showcase";
import Hearing from "@/pages/Hearing";
import Today from "@/pages/Today";
import Timeline from "@/pages/Timeline";
import HearingPublic from "@/pages/HearingPublic";
import Quizzes from "@/pages/Quizzes";
import Planning from "@/pages/Planning";
import Requests from "@/pages/Requests";
import Dashboard from "@/pages/Dashboard";
import Students from "@/pages/Students";
import Alumni from "@/pages/Alumni";
import Dropped from "@/pages/Dropped";
import Curriculum from "@/pages/Curriculum";
import Setup from "@/pages/Setup";
import StudentDetail from "@/pages/StudentDetail";
import Kanban from "@/pages/Kanban";
import Academics from "@/pages/Academics";
import Schedule from "@/pages/Schedule";
import Attendance from "@/pages/Attendance";
import Modules from "@/pages/Modules";
import Scoring from "@/pages/Scoring";
import Attitude from "@/pages/Attitude";
import Assessment from "@/pages/Assessment";
import Certificates from "@/pages/Certificates";
import Alerts from "@/pages/Alerts";
import Reports from "@/pages/Reports";
import UsersPage from "@/pages/UsersPage";
import AuditLog from "@/pages/AuditLog";
import Settings from "@/pages/Settings";
import Verify from "@/pages/Verify";
import Join from "@/pages/Join";
import Play from "@/pages/Play";
import LiveHost from "@/pages/LiveHost";
import StudentQrPrint from "@/pages/StudentQrPrint";
import { ForgotPassword, ResetPassword } from "@/pages/PasswordReset";

function Protected({ children }) {
  const { user } = useAuth();
  if (user === null) return <div className="h-screen grid place-items-center text-slate-500">Loading...</div>;
  if (user === false) return <Navigate to="/login" replace />;
  return children;
}

function AppRoutes() {
  const location = useLocation();
  if (location.hash?.includes("session_id=")) return <GoogleCallback />;
  return (
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/verify/:number" element={<Verify />} />
            <Route path="/join" element={<Join />} />
            <Route path="/h/:token" element={<HearingPublic />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/reset-password/:token" element={<ResetPassword />} />
            <Route path="/magic/:token" element={<MagicLogin />} />
            <Route path="/play/:token" element={<Play />} />
            <Route path="/students/qr-print" element={<Protected><StudentQrPrint /></Protected>} />
            <Route element={<Protected><AppLayout /></Protected>}>
              <Route path="/" element={<Dashboard />} />
              <Route path="/guide" element={<Guide />} />
              <Route path="/showcase" element={<Showcase />} />
              <Route path="/hearing" element={<Hearing />} />
              <Route path="/today" element={<Today />} />
              <Route path="/timeline" element={<Timeline />} />
              <Route path="/quizzes" element={<Quizzes />} />
              <Route path="/quizzes/live/:id" element={<LiveHost />} />
              <Route path="/planning" element={<Planning />} />
              <Route path="/requests" element={<Requests />} />
              <Route path="/students" element={<Students />} />
              <Route path="/alumni" element={<Alumni />} />
              <Route path="/dropped" element={<Dropped />} />
              <Route path="/curriculum" element={<Curriculum />} />
              <Route path="/setup" element={<Setup />} />
              <Route path="/students/:id" element={<StudentDetail />} />
              <Route path="/kanban" element={<Kanban />} />
              <Route path="/academics" element={<Academics />} />
              <Route path="/schedule" element={<Schedule />} />
              <Route path="/attendance" element={<Attendance />} />
              <Route path="/modules" element={<Modules />} />
              <Route path="/scoring" element={<Scoring />} />
              <Route path="/attitude" element={<Attitude />} />
              <Route path="/assessment" element={<Assessment />} />
              <Route path="/certificates" element={<Certificates />} />
              <Route path="/alerts" element={<Alerts />} />
              <Route path="/reports" element={<Reports />} />
              <Route path="/users" element={<UsersPage />} />
              <Route path="/access" element={<UsersPage mode="full" />} />
              <Route path="/audit" element={<AuditLog />} />
              <Route path="/settings" element={<Settings />} />
            </Route>
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
  );
}

function App() {
  return (
    <I18nProvider>
      <AuthProvider>
        <BrowserRouter>
          <AppRoutes />
        </BrowserRouter>
        <Toaster richColors position="top-right" />
      </AuthProvider>
    </I18nProvider>
  );
}

export default App;
